import { render, staticRenderFns } from "./shop-orders.vue?vue&type=template&id=1ac6c3c6&scoped=true"
import script from "./shop-orders.vue?vue&type=script&lang=js"
export * from "./shop-orders.vue?vue&type=script&lang=js"
import style0 from "./shop-orders.vue?vue&type=style&index=0&id=1ac6c3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac6c3c6",
  null
  
)

export default component.exports